import { useCallback, useState } from "react"

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../../../Components/Button"
import ExportDropdown from "../../../../../Components/Export"
import Icon from "../../../../../Icon"
import { FaqStub } from "../../../components/FaqStub"
import { selectExportFetching } from "../../redux/compelling-evidence.slice"
import { getCompellingEvidenceFaq } from "../../redux/compelling-evidence.thunks"

// Registered in TitleSectionContext by the page. On a phone Export moves up here, since the
// filter bar has no room for it.
const HeaderActions = ({ isMobile, isActive, isDemo, onExport }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const exportFetching = useSelector(selectExportFetching)

  const loadFaq = useCallback(() => dispatch(getCompellingEvidenceFaq()).unwrap(), [dispatch])

  return (
    <>
      {open && (
        <FaqStub
          isMobile={isMobile}
          open={open}
          onClose={() => setOpen(false)}
          description={t(
            "Learn how Compelling Evidence and First-Party Trust use your past orders to stop fraud disputes."
          )}
          loadItems={loadFaq}
        />
      )}

      <Button
        type="default"
        icon={<Icon type="question_help" style={isMobile ? {} : { fontSize: 16 }} />}
        onClick={() => setOpen(true)}
      >
        {!isMobile && t("Learn more about Compelling Evidence")}
      </Button>

      {isMobile && isActive && (
        <ExportDropdown
          loading={exportFetching}
          onExport={onExport}
          disabled={isDemo}
          iconButton
          inHeader
        />
      )}
    </>
  )
}

export default HeaderActions
